import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import { selectGradeYear } from '../../../../api/studentSummary/shared/studentSummaryActions';
import { fetchItemLevelDetails } from '../../../../api/results/shared/resultActions';
import { getTrcResultsWithoutDetails } from '../../../../utils/shared/trcUtils';
import TrcSummary from '../../../../features/studentSummary/shared/trcSummary/TrcSummary';
import SkylightClient from '../../../../api/clients/reading/SkylightClient';
import { selectors } from '../../../../root/reading/root';
import TrcContent from '../../../../features/studentSummary/reading/trcSummary/trcContent/TrcContent';
import { getTrcCards } from '../../../../features/studentSummary/reading/trcSummary/trcSummaryUtils';
import LinkWrapper from '../../../../features/navigation/LinkWrapper';
import { ASSESSMENT } from '../../../../constants/shared/ApiConstants';
import { LRS_TAB_NAME } from '../../../../constants/shared/LrsConstants';
import openProbeDetails from '../../../../api/probeDetails/probeDetailsActions';
import ProbeDetailsPageContainer from '../../../probeDetails/reading/ProbeDetailsPageContainer';
import { getGradeYearString } from '../../../../features/studentSummary/shared/common/gradeNavTabs';

const mapStateToProps = state => {
    const studentResults = selectors.getStudentResultsByStudentId(
        state,
        selectors.getSelectedStudentId(state),
    );
    const trcSummaryData = selectors.getTrcSummaryData(state);
    const summeryLabel = selectors.getSummerPeriodLabel(state);

    return {
        location: selectors.getLocation(state),
        studentId: selectors.getSelectedStudentId(state),
        selectedGradeYear: selectors.getSelectedGradeYear(state),
        gradeYears: selectors.getGradeYears(state),
        isDetailsReadyForRendering: isEmpty(getTrcResultsWithoutDetails(studentResults)),
        isGradeYearsFetching: selectors.isGradeYearsFetching(state),
        areResultsUpdating: selectors.areResultsUpdating(state),
        currentSchoolYear: selectors.getCurrentSchoolYear(state),
        cards: getTrcCards(trcSummaryData, summeryLabel),
        trcSummaryData,
        studentResults,
        LinkWrapper,
        TrcContent,
        ProbeDetailsPageContainer,
        summeryLabel,
    };
};

const mapDispatchToProps = dispatch => ({
    switchGradeYear: (gradeYearPair, studentId) =>
        dispatch(selectGradeYear(gradeYearPair, studentId, LRS_TAB_NAME.TEXT_READING_HISTORY)),
    openProbeDetails: (resultId, bookId) => dispatch(openProbeDetails(resultId, bookId)),
    fetchTrcItemLevelDetails: results =>
        dispatch(fetchItemLevelDetails(ASSESSMENT.TRC, SkylightClient, results)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { studentId, gradeYears, currentSchoolYear } = stateProps;
    const currentGradeYear = gradeYears.find(({ year }) => year === currentSchoolYear);
    const defaultGradeYear = getGradeYearString(currentGradeYear);
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        selectGradeYear: gradeYearPair => {
            const gradeYear = gradeYearPair || defaultGradeYear;
            dispatchProps.switchGradeYear(gradeYear, studentId);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TrcSummary);
